var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 15H4.16634C3.7061 15 3.33301 15.3731 3.33301 15.8333C3.33301 16.2936 3.7061 16.6667 4.16634 16.6667H15.833C16.2932 16.6667 16.6663 16.2936 16.6663 15.8333C16.6663 15.3731 16.2932 15 15.833 15Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 14.167V15.8337C3.33301 16.2939 3.7061 16.667 4.16634 16.667C4.62658 16.667 4.99967 16.2939 4.99967 15.8337V14.167C4.99967 13.7068 4.62658 13.3337 4.16634 13.3337C3.7061 13.3337 3.33301 13.7068 3.33301 14.167Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.167V15.8337C15 16.2939 15.3731 16.667 15.8333 16.667C16.2936 16.667 16.6667 16.2939 16.6667 15.8337V14.167C16.6667 13.7068 16.2936 13.3337 15.8333 13.3337C15.3731 13.3337 15 13.7068 15 14.167Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 12.4997C9.82711 12.501 9.65821 12.4486 9.51654 12.3497L6.18321 9.99968C6.00355 9.87223 5.88166 9.67884 5.84419 9.46178C5.80671 9.24472 5.85669 9.02165 5.98321 8.84134C6.04637 8.75122 6.12675 8.67449 6.21972 8.6156C6.31268 8.55671 6.4164 8.51681 6.52486 8.49822C6.63333 8.47962 6.74441 8.48269 6.85169 8.50726C6.95896 8.53183 7.06031 8.5774 7.14988 8.64134L9.99988 10.633L12.8332 8.49968C13.01 8.36707 13.2323 8.31013 13.4511 8.34139C13.6699 8.37264 13.8673 8.48953 13.9999 8.66634C14.1325 8.84316 14.1894 9.0654 14.1582 9.2842C14.1269 9.50299 14.01 9.7004 13.8332 9.83301L10.4999 12.333C10.3556 12.4412 10.1802 12.4997 9.99988 12.4997Z",
    fill: "#555555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 10.8333C9.77931 10.8333 9.56735 10.7455 9.41107 10.5893C9.25479 10.433 9.16699 10.221 9.16699 10V3.33333C9.16699 3.11232 9.25479 2.90036 9.41107 2.74408C9.56735 2.5878 9.77931 2.5 10.0003 2.5C10.2213 2.5 10.4333 2.5878 10.5896 2.74408C10.7459 2.90036 10.8337 3.11232 10.8337 3.33333V10C10.8337 10.221 10.7459 10.433 10.5896 10.5893C10.4333 10.7455 10.2213 10.8333 10.0003 10.8333Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.7f0db15a1adf768de6ff89c9d3873fa0.svg";
export { ForwardRef as ReactComponent };